import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useMemo } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';

export const QueueDashboardEmpty = (): JSX.Element => {
  const navigate = useAppNavigate();

  const {
    params: { type },
  } = useAppSearchParams('/dashboard');

  const emptyState = useMemo((): JSX.Element => {
    switch (type) {
      case 'agent':
        return (
          <EmptyState
            title="You are not assigned to any queues."
            description="Queues that you are assigned to will appear here."
            icon="user"
            buttonProps={{
              children: 'See all queues',
              onClick: () => {
                ampli.dashboardQueuesTypeChanged({
                  type: 'all',
                  location: 'queuesMessageButton',
                });

                navigate({
                  path: '/dashboard',
                  params: {
                    search: {
                      type: 'all',
                    },
                  },
                });
              },
            }}
          />
        );

      case 'favourite':
        return (
          <EmptyState
            title="You do not have any favorite queues."
            description="Click on the star icon next to a queue to add it to your favorites."
            icon="star"
            buttonProps={{
              children: 'See assigned queues',
              onClick: () => {
                ampli.dashboardQueuesTypeChanged({
                  type: 'agent',
                  location: 'favoritesMessageButton',
                });

                navigate({
                  path: '/dashboard',
                  params: {
                    search: {
                      type: 'agent',
                    },
                  },
                });
              },
            }}
          />
        );

      case 'archived':
        return (
          <EmptyState
            title="There are no archived queues."
            description="Queues that have been archived will appear here."
            icon="archive"
            buttonProps={{
              children: 'See all queues',
              onClick: () => {
                ampli.dashboardQueuesTypeChanged({
                  type: 'all',
                  location: 'archivedQueuesMessageButton',
                });

                navigate({
                  path: '/dashboard',
                  params: {
                    search: {
                      type: 'all',
                    },
                  },
                });
              },
            }}
          />
        );

      case 'all':
      default:
        return (
          <EmptyState
            title="There are no queues."
            description="Your organization does not have any queues yet."
            icon="info"
            buttonProps={{
              children: 'Go to Settings',
              onClick: () => navigate({ path: '/settings/queues' }),
            }}
          />
        );
    }
  }, [type, navigate]);

  return (
    <FlexBox
      flexDirection="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      {emptyState}
    </FlexBox>
  );
};
